const STORAGE_KEY = "vcrm_tareas_filtros_v1";

export function guardarFiltrosTareasSession(filtros) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filtros));
  } catch {
    /* ignore */
  }
}

export function leerFiltrosTareasSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
